'use client';
import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import cn from 'clsx';
import SvgArrow from './../packages/granat-react/packages/tabs/ext/@mts-ds/granat/src/components/tabs/assets/arrow.svg.js';
import styles from '../tabs.module.scss.js';
import { SelectContext } from '../context/select-context.js';

/**
 * Компонент Tab
 */
const MtsDsTab = function Tab({
  id,
  text,
  active: rawActive,
  children,
  withArrow,
  onChange,
  ariaControls,
  ariaLabel
}) {
  const [active, setActive] = useState(rawActive);
  const {
    activeTab,
    setActiveTab,
    type
  } = useContext(SelectContext);
  useEffect(() => {
    if (activeTab === id) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [activeTab, id, onChange]);
  useEffect(() => {
    setActive(rawActive);
  }, [rawActive]);
  const onMouseClickHandler = () => {
    setActiveTab(id);
    if (onChange) {
      onChange(id);
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    className: cn(styles['mtsds-tabs__item'], active && [styles['mtsds-tabs__item--active'], type === 'stroke' && styles['mtsds-tabs__item--open']])
  }, /*#__PURE__*/React.createElement("button", {
    role: "tab",
    "aria-selected": active,
    "aria-controls": ariaControls,
    "aria-label": ariaLabel || text,
    type: "button",
    className: styles['mtsds-tabs__tab'],
    onClick: onMouseClickHandler
  }, /*#__PURE__*/React.createElement("p", {
    className: styles['mtsds-tabs__tab-name'],
    "aria-hidden": true
  }, text), children && /*#__PURE__*/React.createElement("div", {
    className: styles['mtsds-tabs__tab-counter'],
    "aria-hidden": true
  }, children), !children && withArrow && type !== 'button' && /*#__PURE__*/React.createElement("div", {
    className: styles['mtsds-tabs__tab-icon'],
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(SvgArrow, null))));
};

export { MtsDsTab, MtsDsTab as Tab };
